<template>
  <div id="visualization">
    <v-flex md12 style="padding-top:1%;" text-xs-right>
      <v-btn color="primary" id="moveLeft" @click="move(0.2)">
        <v-icon>icons8-sort-left</v-icon>
      </v-btn>
      <v-btn color="primary" id="moveRight" @click="move(-0.2)">
        <v-icon>icons8-sort-right</v-icon>
      </v-btn>
    </v-flex>
  </div>
</template>

<script>
import vis from "vis";
import { mapState } from "vuex";
import adminSchema from "@/schemas/admin.json";
import { setTimeout } from "timers";
import * as moment from "moment";

var container = {};
var items = {};
var options = {};
var timeline = {};

export default {
  name: "Timeline",
  data() {
    return {
      rows: []
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      clip: state => state.clip,
      gameID: state => state.game.gameID,
      sponByGameResult: state => state.clip.sponByGameResult,
      actionsBtns: state => state.actionsBtns
    })
  },
  watch: {
    sponByGameResult: {
      handler: function() {
        this.rows = this.sponByGameResult;
      },
      immediate: true,
      deep: true
    },
    watchRows: {
      handler: function() {
        this.rows;
      },
      deep: true
    }
  },
  methods: {
    pressButton(id) {
      for (var i = 0; i < this.rows.length; i++) {
        if (id === this.rows[i].id) {
          this.$store.commit("actionsBtns/setButtonEmpty");
          this.$store.commit("actionsBtns/setButtonPressed", "playGameMoment");
          this.$store.dispatch("actionsBtns/sendData", [
            this.rows[i].clipStart,
            this.rows[i].clipDuration,
            "actionsBtns/setResult"
          ]);
        }
      }
    },
    changeTimeFormat(time) {
      var s = Math.floor(time % 60);
      var m = Math.floor((time / 60) % 60);
      var h = Math.floor(time / 3600);
      if (isNaN(time) || time === Infinity) {
        h = m = s = "--";
      }
      h = h > 0 ? h + ":" : "";
      m = (h && m < 10 ? "0" + m : m) + ":";
      s = s < 10 ? "0" + s : s;
      return (time = h + m + s);
    },
    move(percentage) {
      var range = timeline.getWindow();
      var interval = range.end - range.start;
      timeline.setWindow({
        start: range.start.valueOf() - interval * percentage,
        end: range.end.valueOf() - interval * percentage
      });
    },
    returnEarliestClip() {
      var arr = this.rows;
      const closest = arr.reduce((acc, loc) =>
        acc.clipStart < loc.clipStart ? acc : loc
      );
      return closest.clipStart;
    },

    createTimeline() {
      container = document.getElementById("visualization");

      // Create a DataSet (allows two way data-binding)
      items = new vis.DataSet();

      for (var i = 0; i < this.rows.length; i++) {
        items.add([
          {
            id: this.rows[i].id,
            content: this.rows[i].location,
            start: this.rows[i].clipStart
          }
        ]);
      }
      var startTime = this.rows[0].clipStart;
      // Configuration for the Timeline
      options = {
        min: 0,
        max: 7200000,
        //stack: true,
        height: 450,
        start: startTime,
        selectable: true,
        type: "box",
        zoomable: false,
        verticalScroll: true,
        zoomKey: "ctrlKey",
        format: {
          minorLabels: {
            millisecond: "mm:ss",
            second: "mm:ss",
            minute: "HH:mm",
            hour: "ha"
          },
          majorLabels: {
            millisecond: "HH:mm:ss",
            second: "HH:mm:ss",
            minute: "HH:mm:ss",
            hour: "HH:mm:ss",
            weekday: "",
            day: "",
            week: "",
            month: "",
            year: ""
          }
        },
        showMajorLabels: true,
        tooltip: {
          followMouse: true,
          overflowMethod: "cap"
        },
        margin: {
          item: 10,
          axis: 50
        },
        timeAxis: {
          scale:'minute',
          step: 5
        }
      };

      timeline = new vis.Timeline(container, items, options);
      var v = this;
      timeline.on("click", function(params) {
        // console.log("params: " + JSON.stringify(params, null, 2));
        // console.log("params id: " + params.item);
        v.pressButton(params.item);
      });
    }
  },
  mounted() {
    var v = this;
    setTimeout(function() {
      v.createTimeline();
    }, 1000);
    // this.rows = [];
  }
};
</script>

<style>
@import url("https://cdnjs.cloudflare.com/ajax/libs/vis/4.21.0/vis.min.css");

.vis-timeline {
  border-top: 1px solid #bfbfbf !important;
  border-bottom: none;
  border-left: none;
  border-right: none;
}

.vis-panel {
  padding: 2%;
}
</style>
